import React from "react";
import { Button } from "../../pages/home/components/HeroSession.js/HeroSession.styles";
import { FormContainer, InputContainer } from "../betaForm/BetaDetail";

const PaydayDetail = () => {
  return (
    <FormContainer>
      <InputContainer>
        <div>
          <label>Where do you work currently?</label>
          <input placeholder="eg Coca Cola" />
        </div>
        <div>
          <label>Monthly Salary?</label>
          <input placeholder="eg 500,000" />
        </div>
        <div>
          <label>Amount you want to borrow</label>
          <input placeholder="eg, 100,000" />
        </div>
        <div>
          <label>When is your salary date?</label>
          <input placeholder="eg, 25th" />
        </div>
      </InputContainer>
      <div className="submit__button">
        <Button
          style={{ color: "#fff", fontSize: "16px", marginTop: "20px" }}
          to="/contact"
        >
          Finish
        </Button>
      </div>
    </FormContainer>
  );
};

export default PaydayDetail;
